
import './CSS/mintPage.css'
import StateDisplay from './stateDisplay'
import AnimatedPage from './animatedPage'
import BBClogo from './assets/BabyButterflyCartel.png'
import { useLocation } from 'react-router-dom'
import { useEffect, useRef } from 'react'

const MintPage = ({ statePack }) => {

    const fadeIn = [0, 0.14]
    const fadeOut = [0.14, 0]

    const whichFade = useRef(fadeIn)
    const location = useLocation()
    useEffect(() => {
        whichFade.current = (location.pathname === '/') ? fadeOut : fadeIn
    }, [])
    const delay = whichFade.current

    return (

        <div className="mintPageContainer">

            <AnimatedPage delay={delay[0]}>
                <img className="logo" src={BBClogo} alt="Baby Butterfly Cartel logo" />
            </AnimatedPage>

            <AnimatedPage delay={delay[1]}>
                <div className='stateContainer'>
                    <StateDisplay statePack={statePack} />
                </div>
            </AnimatedPage>

        </div>

    )

}

export default MintPage